import React, { isValidElement } from 'react';
import Modal from 'react-modal';

import BaseButton from '../BaseButton/BaseButton';
import styles from './Popup.module.scss';

type TPopupChildren = {
  title: string | JSX.Element;
  description?: string | JSX.Element;
};

type TPopupButton = {
  label: string;
  onClick: React.MouseEventHandler;
};

export interface IPopupProps {
  isOpen: boolean;
  children: TPopupChildren | JSX.Element | string | null | undefined;
  mainBtn: TPopupButton;
  subBtn?: TPopupButton;
  className?: string;
}

const Popup: React.FC<IPopupProps> = ({ isOpen, children, subBtn, mainBtn }) => {
  const renderText = (): JSX.Element | null => {
    if (!children) {
      return null;
    }

    if (typeof children === 'string' || isValidElement(children)) {
      return (
        <div className={styles.textWrap}>
          <div className={styles.title}>{children}</div>
        </div>
      );
    }

    if ('title' in children) {
      return (
        <div className={styles.textWrap}>
          <div className={styles.title}>{children.title}</div>
          {children.description && <div className={styles.description}>{children.description}</div>}
        </div>
      );
    }

    return null;
  };

  return (
    <Modal
      isOpen={isOpen}
      className={{
        afterOpen: styles.containerAfterOpen,
        base: styles.container,
        beforeClose: styles.containerBeforeClose,
      }}
      bodyOpenClassName="ReactModal__Body-NoIE--open"
      overlayClassName={{
        afterOpen: styles.overlayAfterOpen,
        base: styles.overlay,
        beforeClose: styles.overlayBeforeClose,
      }}
      ariaHideApp={false}
      closeTimeoutMS={100}
    >
      {renderText()}
      <div className={styles.buttonsContainer}>
        {subBtn && (
          <div className={styles.buttonWrap}>
            <BaseButton as="button" className={styles.subBtn} onClick={subBtn.onClick}>
              {subBtn.label}
            </BaseButton>
          </div>
        )}
        <div className={styles.buttonWrap}>
          <BaseButton as="button" className={styles.mainBtn} onClick={mainBtn.onClick}>
            {mainBtn.label}
          </BaseButton>
        </div>
      </div>
    </Modal>
  );
};

export default Popup;
